import { MainContainer } from "../../components/Contents/Contents.element"
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactNode, useEffect, useState } from "react";
import IApiResponse from "../../types/IApiResponse";
import { fetchData, postData } from "../../services/api";
import handleApiResponse from "../../utils/handleApiResponse";
import apiUrls from "../../config/apiUrls";
import PageHeader from "../../layout/PageHeader";
import LabelText from "../../ui/LabelText";
import { TabSectionStyles } from "../../styled-components/TabStyles";
import CustomTabs from "../../ui/Tab";
import { ITab } from "../../types/ITab";
import { IClubCardDetail } from "../../types/IClubDetail";
import ClubFinancial from "./ClubFinancial/ClubFinancial";
import { useTheme } from "../../contexts/ThemeContext";
import noImageClub from "../../assets/icons/noImageClub.svg"
import noImageFlag from "../../assets/icons/noImageFlag.svg"
import { SquadTab } from "./Squad/SquadTab";
import { ModuleSpinner } from "../../ui/LoadingSpinner/ModuleSpinner";
import { useClubSearch } from "../../contexts/ClubSearchContext";
import { addUpdateClubSortListData } from "../ClubComparison/addOrUpdateClubSortlist";
import { useAuth } from "../../contexts/AuthContext";
import { useLoading } from "../../contexts/LoadingContext";
import PWNotification from "../PWNotification";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import CustomizedTooltips from "../../ui/Tooltip";
import { getOrdinalSuffix, getLeaguePositionDetails } from '../../utils/clubFormationsFunctions'
import LabelNumber from "../../styled-components/LabelNumber";
import { useSquadSystemFitContext } from "../../contexts/SquadSystemFitContext";
import InfoIcon from '../../assets/icons/infoicon.svg'
import { formatNumberToKAndM, formatNumberToKAndMwithoutsign } from "../../utils/formatNumberToKandM";
import EmptyDataButton from "../../ui/EmptyDataButton";
import PerformanceTab from "./Performance/PerformanceTab";
import Chemistry from "../../pages/Chemistry";
import { useSidebar } from "../../contexts/SidebarContext";
import Possessions from "./Possessions/Possessions";
import PerformanceVersion2 from "./PerformanceVersion2";


const PlayerCardData = styled.div`
    background: ${({ theme }) => theme.playerCardBackground};  
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const PlayerClubInfoData = styled.div<{ country?: string }>`
    border: 1px solid ${({ theme, country }) => country ? 'none' : theme.playerDataBorder};
`;

const PlayerLargeDataText = styled.span`
    color: ${({ theme }) => theme.NumberColor};
`;

const PlayerLargeDataValue = styled.span`
    color: ${({ theme }) => theme.playerDataValueColor};
`;

const PlayerContent = styled.div`
    width: 100%;
    padding-bottom: 20px;
    background: ${({ theme }) => theme.playerContentBackground};
`;

const PlayerClubCountryInfoData = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    .club-image {
        width: 40px; height: 40px; margin-right: 12px; align-content:center;
    }
    .country-image {
        width: 40px; height: 40px; margin-right: 12px; align-content:center; border-radius : 100%; object-fit : cover; border : 1px black solid;
    }
`;

const ClubDetail: React.FC<{ toggle: boolean, isSubSidebarOpen: boolean, isBlurred: boolean }> = (props) => {
    const TABS: ITab[] = [
        { title: 'Simulation', key: 'Performance' },
        // { title: 'Old Performance', key: 'Old Performance' },
        // { title: 'Squad', key: 'Squad' },
        { title: 'Financial', key: 'Financial' },
        // { title: 'Possessions', key: 'Possessions' },
    ];
    const { selectedSeasonId } = useSquadSystemFitContext();
     const { isOpen, subMenuOpen, isBlurred } = useSidebar();
    const { userData } = useAuth();
    const { teamId } = useParams<{ teamId: string }>();
    const [clubData, setClubData] = useState<IClubCardDetail>();
    const [activeTab, setActiveTab] = useState<string>('Performance');
    const { theme } = useTheme();
    const [customloading, setLoading] = useState<boolean>();
    const { toggleAddButton, setIsToggleAddButton, setIsClubSearchOpen, setTeamCompareAttributesData } = useClubSearch();

    const { loading, startLoading, stopLoading } = useLoading();
    const navigate = useNavigate();

    const [addedClubShortList, setAddedClubShortList] = useState<boolean>(false)
    const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
    const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);


    useEffect(() => {
        setActiveTab('Performance')
        setTeamCompareAttributesData([])
        setIsClubSearchOpen(false)
        const fetchClubData = async () => {
            setLoading(true);
            const requestParameters = {
                TeamId: teamId
            };
            const response: IApiResponse<IClubCardDetail> = await postData(apiUrls.GetTeamCardDetails, requestParameters);
            handleApiResponse(response, (teamsData) => {
                setLoading(false);
                setClubData(teamsData);
                setIsToggleAddButton(teamsData?.isTeamInShortlist)
            }, (error) => {
                setLoading(false);
                console.error('Error fetching club card Data:', error);
            });

        };
        fetchClubData();
    }, [teamId]);


    const handleTabClick = (key: string) => {
        window.scrollTo(0, 0);
        setActiveTab(key);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'Performance':
                // return <PerformanceTab teamId={teamId!} clubImg={clubData?.teamLogoURL!} clubName={clubData?.teamName} />;
                return <PerformanceVersion2 teamId={Number(teamId!)} teamName={clubData?.teamName!}/>;
            case 'Old Performance':
                return <PerformanceTab teamId={teamId!} clubImg={clubData?.teamLogoURL!} clubName={clubData?.teamName} />;
            case 'Financial':
                return <ClubFinancial />;
            case 'Squad':
                return <SquadTab teamId={teamId!} clubName={clubData?.teamName} />;
            case 'Possessions':
                return <Possessions teamId={parseInt(teamId!)}/>
                // return <><div style={{width:'1350px'}}><Chemistry isBlurred={isBlurred!} toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} isHeader={false} teamId={parseInt(teamId!)}/></div></>
            default:
                return null;
        }
    };

    const handleAddClub = () => {
        setIsToggleAddButton(!toggleAddButton);
        if (toggleAddButton) {
            setAddedClubShortList(false);
            addUpdateClubSortListData(
                userData,
                [Number(teamId)!],
                startLoading,
                stopLoading,
                setDisplayCustomNotification,
                setCustomNotificationContent,
                true,
                navigate
            );
        } else {
            setAddedClubShortList(true);
            addUpdateClubSortListData(
                userData,
                [Number(teamId)!],
                startLoading,
                stopLoading,
                setDisplayCustomNotification,
                setCustomNotificationContent,
                false,
                navigate
            );
        }
    };

    const handleActions = () => {
        setIsToggleAddButton(!toggleAddButton);
        addUpdateClubSortListData(
            userData,
            [Number(teamId)!],
            startLoading,
            stopLoading,
            setDisplayCustomNotification,
            setCustomNotificationContent,
            false,
            navigate
        );
    };

    useEffect(() => {
        setCustomNotificationContent(
            <div className="notification">
                <p className="sortlist-notofication-content">
                    <BookmarkBorderOutlinedIcon className="icon" />
                    <LabelText className="squad-chart-tooltip notification-content">
                        {!addedClubShortList ? "Club removed from your shortlist" : "Club added to your shortlist"}
                    </LabelText>

                    {!addedClubShortList ? (
                        <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
                            Undo
                        </LabelText>
                    ) : (
                        <LabelText
                            className="player-given-name notification-content"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/shortlists")}
                        >
                            View shortlist
                        </LabelText>
                    )}
                </p>
            </div>
        );
    }, [displayCustomNotification]);

    const { formattedPosition, formattedDifference, differenceColor, tooltipText, expectedPosition } = getLeaguePositionDetails(clubData!);
    const profitLossStyled = clubData?.totalProfitLoss !== 0 && clubData?.totalProfitLoss !== null ? {
        background: clubData?.totalProfitLoss! > 0 ? "#4AF075" : "#FF3864"
    } : {};
    const currentValueDiffStyle = clubData?.currentValue !== 0 ? {
        background: clubData?.currentValue! > 0 ? "#4AF075" : "#FF3864",
        border: 'none',
        borderRadius: '0px'
    } : {};
    const valueDiffBorder = clubData?.currentValue !== 0
        ? {
            border: clubData?.currentValue! > 0
                ? "1px solid #4AF075"
                : "1px solid #FF3864"
        }
        : {};


    return (
        <div className="cmn-main-container">
            <MainContainer isBlurred={props.isBlurred} active={props.toggle} isSubSidebarOpen={props.isSubSidebarOpen} className="main-container player-detail-page">
                <PageHeader img={clubData?.teamLogoURL ? clubData?.teamLogoURL : noImageClub} name={clubData?.teamName}
                    isBookmark={false} isSimulate={false} isShare={false} pageName="club-detail" isAddtoSortlis={true} handleAddPlayer={handleAddClub} isPlayerInShortlist={toggleAddButton}
                    activeTab={activeTab}
                />
                <div className="player-card-data-main">
                    <PlayerCardData className="player-card-data">
                        <div className="player-card-detail">
                            <div className="player-header">
                                <img src={clubData?.teamLogoURL ? clubData?.teamLogoURL : noImageClub} alt='club-image' width={140} height={140} />
                            </div>
                            <div className="player-name-header">
                                <div className="clubName-position-container">
                                    <LabelText className='player-detail-given-name' style={{ color: theme.NumberColor }}>{clubData?.competitionName}</LabelText>
                                    {(clubData?.currentLeaguePosition !== 0 && clubData?.currentLeaguePosition !== null) && (
                                        <LabelText className='player-detail-given-name' style={{ color: theme.NumberColor }}>{"  • Currently " + formattedPosition} </LabelText>
                                    )}
                                    {(clubData?.currentLeaguePosition === 0 || clubData?.currentLeaguePosition === null) && clubData?.currentExpectedLeaguePosition && (
                                        <LabelText className='player-detail-given-name' style={{ color: theme.NumberColor }}>{"  • Expected league pos. " + expectedPosition} </LabelText>
                                    )}
                                    {(clubData?.currentExpectedLeaguePosition === 0 || clubData?.currentExpectedLeaguePosition === null) &&
                                        (clubData?.currentLeaguePosition === 0 || clubData?.currentLeaguePosition === null) ? (
                                        <CustomizedTooltips title="Actual and Expected league pos. data not available for this league">
                                            <img src={InfoIcon} width={24} height={24} style={{ marginTop: '4px' }} />
                                        </CustomizedTooltips>
                                    ) : (clubData?.currentExpectedLeaguePosition === 0 || clubData?.currentExpectedLeaguePosition === null) ? (
                                        <CustomizedTooltips title="Expected league pos. data not available for this league">
                                            <img src={InfoIcon} width={24} height={24} style={{ marginTop: '4px' }} />
                                        </CustomizedTooltips>
                                    ) : (clubData?.currentLeaguePosition === 0 || clubData?.currentLeaguePosition === null) ? (
                                        <CustomizedTooltips title="Actual league pos. data not available for this league">
                                            <img src={InfoIcon} width={24} height={24} style={{ marginTop: '4px' }} />
                                        </CustomizedTooltips>
                                    ) : null}
                                    {(clubData?.currentLeaguePosition && clubData?.currentExpectedLeaguePosition) && (
                                        <CustomizedTooltips title={tooltipText}>
                                            <div className="expected-league-container" style={{ width: '22px', height: '24px' }}><LabelNumber style={{ color: differenceColor }}>{formattedDifference}</LabelNumber></div>
                                        </CustomizedTooltips>
                                    )}
                                </div>
                                <div className="player-name-squad" style={{ paddingTop: "0px", width: '630px' }}>
                                    <LabelText className='player-detail-family-name'>{clubData?.teamName}</LabelText>

                                </div>
                                <div style={{ alignSelf: 'flex-end', marginTop: '-30px' }}>
                                    <LabelNumber className="stat-row-value">Manager:</LabelNumber>
                                    <LabelText className="player-given-name">{clubData?.manager}</LabelText>
                                </div>
                                <div className="player-clubInfo" style={{ paddingLeft: '0px' }}>
                                    <PlayerClubCountryInfoData>
                                        <PlayerClubInfoData country="country" className="player-descriptive-data">
                                            <PlayerLargeDataText className="descriptive-text">Country</PlayerLargeDataText>
                                            <PlayerLargeDataValue className="descriptive-value">{clubData?.countryName}</PlayerLargeDataValue>
                                        </PlayerClubInfoData>
                                        <img src={clubData?.countryCode ? `/assets/country_flags/${clubData?.countryCode || ''}.svg` : noImageFlag}
                                            alt="Country Flag" className="country-image" />
                                    </PlayerClubCountryInfoData>
                                    {/* <PlayerClubInfoData className="player-descriptive-data">
                                        <PlayerLargeDataText className="descriptive-text">League Pos</PlayerLargeDataText>
                                        <PlayerLargeDataValue className="descriptive-value">{clubData?.leaguePosition}</PlayerLargeDataValue>
                                    </PlayerClubInfoData> */}
                                    {/* <PlayerClubInfoData className="player-descriptive-data">
                                        <PlayerLargeDataText className="descriptive-text">Highest wage pw</PlayerLargeDataText>
                                        <PlayerLargeDataValue className="descriptive-value">€{clubData?.highestWageText}</PlayerLargeDataValue>
                                    </PlayerClubInfoData>
                                    <PlayerClubInfoData className="player-descriptive-data">
                                        <PlayerLargeDataText className="descriptive-text">Average wage pw</PlayerLargeDataText>
                                        <PlayerLargeDataValue className="descriptive-value">€{clubData?.averageWageText}</PlayerLargeDataValue>
                                    </PlayerClubInfoData> */}
                                    <PlayerClubInfoData className="player-descriptive-data">
                                        <PlayerLargeDataText className="descriptive-text">Revenue per season</PlayerLargeDataText>
                                        <PlayerLargeDataValue className="descriptive-value">€{formatNumberToKAndM(clubData?.totalRevenue!)}</PlayerLargeDataValue>
                                    </PlayerClubInfoData>
                                    <PlayerClubInfoData className="player-descriptive-data">
                                        <PlayerLargeDataText className="descriptive-text">Costs per season</PlayerLargeDataText>
                                        <PlayerLargeDataValue className="descriptive-value">€{formatNumberToKAndM(clubData?.totalCosts!)}</PlayerLargeDataValue>
                                    </PlayerClubInfoData>
                                    <PlayerClubInfoData className="player-descriptive-data" style={profitLossStyled}>
                                        <LabelNumber className="descriptive-large-text">Profit/loss</LabelNumber>
                                        <LabelNumber className="descriptive-large-value">
                                            {clubData?.totalProfitLoss ? (
                                                `${clubData?.totalProfitLoss >= 0 ? '+' : '-'}€${formatNumberToKAndMwithoutsign(clubData?.totalProfitLoss)}`
                                            ) : (
                                                <EmptyDataButton label="Data not provided by club" />
                                            )}</LabelNumber>
                                    </PlayerClubInfoData>
                                    <div style={{ display: "flex", borderRadius: "4px", ...valueDiffBorder }}>
                                        <PlayerClubInfoData className="player-descriptive-data" style={{ border: 'none' }}>
                                            <LabelNumber className="descriptive-large-text">Squad purchase cost</LabelNumber>
                                            <LabelNumber className="descriptive-large-value">{clubData?.totalPurchaceCost ? (
                                                `€${formatNumberToKAndMwithoutsign(clubData?.totalPurchaceCost)}`
                                            ) : (
                                                <EmptyDataButton label="Data not provided by club" />
                                            )}</LabelNumber>
                                        </PlayerClubInfoData>
                                        <PlayerClubInfoData className="player-descriptive-data" style={currentValueDiffStyle}>
                                            <LabelNumber className="descriptive-large-text">vs current value</LabelNumber>
                                            <LabelNumber className="descriptive-large-value">{clubData?.currentValue ? (
                                                `${clubData?.currentValue >= 0 ? '+' : '-'}€${formatNumberToKAndMwithoutsign(clubData?.currentValue)}`
                                            ) : (
                                                <EmptyDataButton label="Data not provided by club" />
                                            )}</LabelNumber>
                                        </PlayerClubInfoData>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PlayerCardData>
                    {customloading && <ModuleSpinner />}
                </div>
                <PlayerContent className={activeTab === 'Squad' || activeTab === "Performance" ? "club-tab-main" : "main-player-container-new"}>
                    <TabSectionStyles className="tab-section" style={{zIndex: 11}}>
                        <CustomTabs tabs={TABS} activeTabKey={activeTab} onTabClick={handleTabClick} />
                    </TabSectionStyles>
                    {renderTabContent()}
                </PlayerContent>
                {displayCustomNotification && (
                    <PWNotification
                        message={customNotificationContent}
                        setIsNotification={() => setDisplayCustomNotification(false)}
                        isDisplayCloseIcon={true}
                        className="player-filter-notification add-similar-notification"
                    />
                )}
            </MainContainer>

        </div>
    )
}

export default ClubDetail;